import { ParticipantRole } from '@typings/participant';

export const roleLabels: Record<ParticipantRole, string> = {
  [ParticipantRole.Host]: 'Host',
  [ParticipantRole.CoHost]: 'Co-host',
  [ParticipantRole.Listener]: '',
  [ParticipantRole.Speaker]: '',
};
